import React from 'react';
import { CloudSyncOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from 'antd';
import { useLocation } from 'react-router';

const LoginButton = () => {
	const { loginWithRedirect, isAuthenticated } = useAuth0();
	const location = useLocation();
	if (isAuthenticated) return null;
	const handleLogin = () => {
		loginWithRedirect({
			appState: { returnTo: location.pathname },
		});
	};
	return (
		<Button onClick={handleLogin} block>
			<CloudSyncOutlined className="-ml-0.5 h-5 w-5" aria-hidden="true" />
			LOG IN WITH SSO
		</Button>
	);
};

export default LoginButton;
